/* eslint-disable react/react-in-jsx-scope */
export function LeftCustomSvgIcon(props) {
  const { color, className } = props;
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="208.000000pt"
      height="66.000000pt"
      viewBox="0 0 208.000000 66.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g
        transform="translate(0.000000,66.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M1 580 c-2 -201 122 -420 287 -508 132 -70 80 -66 980 -70 l812 -3 0
   175 0 176 -907 2 -908 3 -58 29 c-63 32 -149 116 -171 168 -8 18 -19 44 -24
   58 -9 22 -11 18 -11 -30z"
        />
      </g>
    </svg>
  );
}

export function RightCustomSvgIcon(props) {
  const { color, className } = props;
  return (
    <svg
      className={className}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="208.000000pt"
      height="66.000000pt"
      viewBox="0 0 208.000000 66.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,66.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M2066 605 c-23 -83 -104 -175 -196 -222 l-55 -28 -907 -3 -908 -2 0
  -176 0 -175 813 3 c754 3 816 5 867 22 202 67 342 226 386 435 16 80 17 204 0
  146z"
        />
      </g>
    </svg>
  );
}

export function DaggerSvgIcon(props) {
  const { color, style } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill={color}
        d="m22 2l-4.61 1.75l-6.93 6.93L14 14.22l6.92-6.93C22.43 5.78 22 2 22 2M8.33 10l-1.41 1.39l1.41 1.41l-5.65 5.66L6.21 22l5.66-5.66l1.41 1.42l1.42-1.42L8.33 10Z"
      />
    </svg>
  );
}
